import { createSelector } from 'reselect';

const selectDiscounts = (state: any) => state.discounts;


export const selectDiscountCurrentItem = createSelector([selectDiscounts], (discounts) => discounts.current);

export const selectDiscountsListItems = createSelector([selectDiscounts], (discounts) => discounts.list);

export const selectDiscountItemById = (itemId: any) =>
    createSelector(selectDiscountsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDiscountQueryItems = createSelector([selectDiscounts], (discounts) => discounts.query);

export const selectDiscountCreatedItem = createSelector([selectDiscounts], (discounts) => discounts.create);

export const selectDiscountUpdatedItem = createSelector([selectDiscounts], (discounts) => discounts.update);

export const selectDiscountReadItem = createSelector([selectDiscounts], (discounts) => discounts.read);

export const selectDiscountDeletedItem = createSelector([selectDiscounts], (discounts) => discounts.delete);

export const selectDiscountSearchedItems = createSelector([selectDiscounts], (discounts) => discounts.search);

export const selectDiscountItemsCount = createSelector([selectDiscounts], (discounts) => discounts.count);

export const selectDiscountItemsFilter = createSelector([selectDiscounts], (discounts) => discounts.filter);